import { atom } from "@workflows/runtime-web";
export const dcocomComplaintIntakeFormStep = atom({
  key: "dcocomComplaintIntakeFormState",
  default: 1
});
export const dcocomComplaintIntakeFormIsPersonalComplaint = atom({
  key: "dcocomComplaintIntakeFormIsPersonalComplaint",
  default: true
});
export const dcocomComplaintIntakeFormURLs = ["/", "/complaint/on-behalf", "/complaint/personal-data", "/complaint/address", "/complaint/content", "/complaint/submit"];